<div class="container-fluid">

    <!-- Search Row -->
    <div class="row py-2">
        <div class="col-12 col-md-4 d-flex">
            <div class="form-floating w-100">
                <select class="form-select" [(ngModel)]="selectedCity" [ngModelOptions]="{standalone: true}" (change)="applyFilters()">
                    <option value="">All Cities</option>
                    <option *ngFor="let c of uniqueCities" [value]="c">{{ c }}</option>
                </select>
                <label>Filter by City</label>
            </div>
        </div>
        <div class="col-12 col-md-4 d-flex">
            <div class="form-floating w-100 justify-content-end">
                <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchText"
                    [ngModelOptions]="{standalone: true}" />
                <label>Search</label>
            </div>
        </div>
        <div class="col-12 col-md-4 d-flex">
            <p class="text-danger">Note: Event registration date is closed — Download and registration link will not be displayed in the table.</p>
        </div>
    </div>

    <!-- Event Table Card -->
    <mat-card class="order-card mt-3">
        <mat-card-content>
            <div class="table-responsive table-style table-bordered">
                <table class="table table-gray table-head-fixed">
                    <thead class="h6">
                        <tr>
                            <th>S.No</th>
                            <th>Event Name</th>
                            <th>Event Date</th>
                            <th>City</th>
                            <th>Registration Link</th>
                            <th>Edit</th>
                            <th>Event QR Code</th>
                        </tr>
                    </thead>

                    <!-- Table Body -->
                    <tbody *ngIf="filteredEvents.length > 0; else noDataFound">
                        <tr class="text-center" *ngFor="let work of filteredEvents | filter: searchText; let i = index">
                            <td>{{ i + 1 }}</td>
                            <td>{{ work?.eventName || "-" }}</td>
                            <td>{{ work?.eventDate | date: "MM/dd/yyyy" }}</td>
                            <td>{{ work?.city || "-" }}</td>
                            <td>
                                <ng-container *ngIf="isEventActive(work?.endDate); else noLink">
                                    <a [href]="getEventLink((work?.city))" target="_blank">
                                        {{ getEventLink((work?.city)) }}
                                    </a>
                                </ng-container>
                                <ng-template #noLink>-</ng-template>
                            </td>
                            <td>
                                <button type="button" class="btn btn-danger btn-sm rounded-pill"
                                    (click)="onEdit(work?.eventId)" aria-label="Edit event">
                                    <i class="fa fa-edit me-2" aria-hidden="true"></i> Edit
                                </button>
                            </td>
                            <td>
                                <ng-container *ngIf="isEventActive(work?.endDate); else noQR">
                                    <button class="btn btn-primary btn-sm" (click)="directDownload(work)">
                                        Download QR Code
                                    </button>

                                </ng-container>
                                <ng-template #noQR>-</ng-template>

                            </td>

                        </tr>
                    </tbody>

                    <!-- No Data -->
                    <ng-template #noDataFound>
                        <tr>
                            <td colspan="11" class="text-center fw-bold">Data Not Found</td>
                        </tr>
                    </ng-template>

                </table>
            </div>
        </mat-card-content>
    </mat-card>

</div>

<!-- Modal -->
<!-- Hidden QR Download Wrapper -->
<!-- Hidden QR Download Wrapper -->
<!-- Hidden Wrapper for Download -->
<div id="hidden-download-wrapper" style="position: fixed; left: -9999px; top: -9999px;">

    <div class="modal-bg-wrapper">

        <!-- Background image MUST be <img> -->
        <img id="bgImg" src="../../../../assets/img/velmaral-ticket-qr-new.jpg" class="bg-template" />

        <!-- QR Code -->
        <img id="hiddenQrImg" [src]="qrCodeUrl" class="qr" />


        <!-- Event Date -->
        <div class="event-date">தேதி: {{ eventDate | date:'dd MMM yyyy' }}</div>

        <!-- Event Venue -->
        <div class="event-venue">இடம்: {{ eventVenue }}</div>

    </div>

</div>